import { useApiQuery } from '../../../hooks/useApiQuery';
import { fetchTemplateDetails } from '../api/logbookApi';

interface RawLogbookTemplateDetails {
    logbookTemplateId: string;
    name: string;
    description: string;
    type: {
        label: string;
        value: string;
    };
    category: {
        label: string;
        value: string;
    };
    templateImageAttachmentDetails: {
        attachmentId: string;
        filename: string;
        mimetype: string;
        attachmentLink: string;
    };
}

export interface LogbookTemplateDetailsData {
    logbookTemplateId: string;
    name: string;
    description: string;
    type: string;
    category: string;
    imageUrl: string;
    imageFilename: string;
    attachmentId: string;
}

const transformLogbookDetails = (
    rawDetails: RawLogbookTemplateDetails
): LogbookTemplateDetailsData => ({
    logbookTemplateId: rawDetails.logbookTemplateId,
    name: rawDetails.name,
    description: rawDetails.description,
    type: rawDetails.type.value,
    category: rawDetails.category.value,
    imageUrl: rawDetails.templateImageAttachmentDetails.attachmentLink,
    attachmentId: rawDetails.templateImageAttachmentDetails.attachmentId,
    imageFilename: rawDetails.templateImageAttachmentDetails.filename,
});

export const useLogbookTemplateDetails = (templateId?: string) => {
    return useApiQuery(
        ['logbookTemplate', templateId],
        () => fetchTemplateDetails(templateId!),
        {
            select: transformLogbookDetails,
            enabled: !!templateId,
        }
    );
};